import React from 'react';
import classNames from 'classnames';
import { Modal } from '../../components';

export const ExportDocModal = (props) => {
    const { show, onClose, onExport, needExport, children } = props;
    const exportBtnCSS = classNames(
        'swegon-like-button',
        needExport ? 'contained' : 'outlined',
        '!px-4',
        needExport ? '' : 'text-gray-50',
    );

    return (
        <Modal
            fitContent
            show={show}
        >
            <div className="p-4 min-w-min ml-4 mr-4 mt-2">
                {children}
                <div className="px-4 py-3 sm:flex sm:px-6 justify-end">
                    <button
                        onClick={onClose}
                        type="button"
                        className="swegon-like-button outlined mr-4 !px-4 amber"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={onExport}
                        type="button"
                        className={exportBtnCSS}
                        disabled={!needExport}
                    >
                        Export
                    </button>
                </div>
            </div>
        </Modal>
    );
};
